import { Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { useDocumentDetails } from "~/Modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { post, put } from "~/Services";
import { decodeHTML } from "~/Utils/CommonUtils";
import { corporateHost } from "~/Utils";
import { fields } from "../constants";
import { useWhistleblowing } from "../CorporateIntegrity.hook";

export const WhistleblowingProgramNextPage = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();
  const { data: corporateIntegrityById, isLoading: isLoadingCorporateIntegrityById, refetch: refetchCorporateIntegrityById } = useDocumentDetails(
    query?.get("id") || ""
  );  
  const { data: whistleblowingData, isLoading: isLoadingWhistleblowing, refetch: refetchWhistleblowing  } = useWhistleblowing();
 
  useEffect(()=>{
    if(!query.get('id')){
        refetchWhistleblowing();
    }
  },[])

  useEffect(()=>{
    if(query.get('id')){
      refetchCorporateIntegrityById();
    }
  },[query.get('id')])
 
  const wDataById = {
    wEn: JSON.parse(
      corporateIntegrityById?.payload?.field_content_english
        ? corporateIntegrityById?.payload?.field_content_english
        : "{}"
    ),
    wMs: JSON.parse(
      corporateIntegrityById?.payload?.field_content_malay
        ? corporateIntegrityById?.payload?.field_content_malay
        : "{}"
    ),
    wZh: JSON.parse(
      corporateIntegrityById?.payload?.field_content_mandarin
        ? corporateIntegrityById?.payload?.field_content_mandarin
        : "{}"
    ),
  };

  const WhistleblowingConfig: FormConfig = {
    initialValues: {
      field_content_english_title: wDataById?.wEn?.data
        ? decodeHTML(wDataById?.wEn?.data?.title)
        : decodeHTML(whistleblowingData?.[0]?.field_content_english?.data?.title),
      field_content_english_descriptions: wDataById?.wEn?.data
        ? decodeHTML(wDataById?.wEn?.data?.descriptions)
        : decodeHTML(whistleblowingData?.[0]?.field_content_english?.data?.descriptions),
      field_content_english_wicStructure_image:
        wDataById?.wEn?.data && wDataById?.wEn?.data
          ? decodeHTML([
              {
                uid: "-1",
                name: "WIC-Structure_image.png",
                status: "done",
                url: wDataById?.wEn?.data?.wicStructure?.image,
              },
            ])
          : whistleblowingData?.[0]?.field_content_english?.data
            ? decodeHTML([
                {
                  uid: "-1",
                  name: "WIC-Structure_image.png",
                  status: "done",
                  url: whistleblowingData?.[0]?.field_content_english?.data?.wicStructure?.image,
                },
              ])
            : [],
      field_content_english_wicStructure_title: wDataById?.wEn?.data
        ? decodeHTML(wDataById?.wEn?.data?.wicStructure?.title)
        : decodeHTML(whistleblowingData?.[0]?.field_content_english?.data?.wicStructure?.title),
      field_content_english_procedure_image:
        wDataById?.wEn?.data && wDataById?.wEn?.data
          ? decodeHTML([
              {
                uid: "-1",
                name: "WIC-Structure_image.png",
                status: "done",
                url: wDataById?.wEn?.data?.procedure?.image,
              },
            ])
          : whistleblowingData?.[0]?.field_content_english?.data
            ? decodeHTML([
                {
                  uid: "-1",
                  name: "WIC-Procedure_image.png",
                  status: "done",
                  url: whistleblowingData?.[0]?.field_content_english?.data?.procedure?.image,
                },
              ])
            : [],
      field_content_english_procedure_title: wDataById?.wEn?.data
        ? decodeHTML(wDataById?.wEn?.data?.procedure?.title)
        : decodeHTML(whistleblowingData?.[0]?.field_content_english?.data?.procedure?.title),
      field_content_english_next_page_name: wDataById?.wEn?.data
        ? decodeHTML(wDataById?.wEn?.data?.nextPage?.name)
        : decodeHTML(whistleblowingData?.[0]?.field_content_english?.data?.nextPage?.name),
      field_content_english_next_page_link: wDataById?.wEn?.data
        ? decodeHTML(wDataById?.wEn?.data?.nextPage?.link)
        : decodeHTML(whistleblowingData?.[0]?.field_content_english?.data?.nextPage?.link),
      field_content_ms_title: wDataById?.wMs?.data
        ? decodeHTML(wDataById?.wMs?.data?.title)
        : decodeHTML(whistleblowingData?.[0]?.field_content_malay?.data?.title),
      field_content_ms_descriptions: wDataById?.wMs?.data
        ? decodeHTML(wDataById?.wMs?.data?.descriptions)
        : decodeHTML(whistleblowingData?.[0]?.field_content_malay?.data?.descriptions),
      field_content_ms_wicStructure_image:
        wDataById?.wMs?.data
          ? decodeHTML([
              {
                uid: "-1",
                name: "WIC-Structure_image.png",
                status: "done",
                url: wDataById?.wMs?.data?.wicStructure?.image,
              },
            ])
          : whistleblowingData
            ? decodeHTML([
                {
                  uid: "-1",
                  name: "WIC-Structure_image.png",
                  status: "done",
                  url: whistleblowingData?.[0]?.field_content_malay?.data?.wicStructure?.image,
                },
              ])
            : [],
      field_content_ms_wicStructure_title: wDataById?.wMs?.data
        ? decodeHTML(wDataById?.wMs?.data?.wicStructure?.title)
        : decodeHTML(whistleblowingData?.[0]?.field_content_malay?.data?.wicStructure?.title),
      field_content_ms_procedure_image:
        wDataById?.wMs?.data
          ? decodeHTML([
              {
                uid: "-1",
                name: "WIC-Structure_image.png",
                status: "done",
                url: wDataById?.wMs?.data?.procedure?.image,
              },
            ])
          : whistleblowingData
            ? decodeHTML([
                {
                  uid: "-1",
                  name: "WIC-Procedure_image.png",
                  status: "done",
                  url: whistleblowingData?.[0]?.field_content_malay?.data?.procedure?.image,
                },
              ])
            : [],
      field_content_ms_procedure_title: wDataById?.wMs?.data
        ? decodeHTML(wDataById?.wMs?.data?.procedure?.title)
        : decodeHTML(whistleblowingData?.[0]?.field_content_malay?.data?.procedure?.title),
      field_content_ms_next_page_name: wDataById?.wMs?.data
        ? decodeHTML(wDataById?.wMs?.data?.nextPage?.name)
        : decodeHTML(whistleblowingData?.[0]?.field_content_malay?.data?.nextPage?.name),
      field_content_ms_next_page_link: wDataById?.wMs?.data
        ? decodeHTML(wDataById?.wMs?.data?.nextPage?.link)
        : decodeHTML(whistleblowingData?.[0]?.field_content_malay?.data?.nextPage?.link),
      field_content_zh_title: wDataById?.wZh?.data
        ? decodeHTML(wDataById?.wZh?.data?.descriptions)
        : decodeHTML(whistleblowingData?.[0]?.field_content_mandarin?.data?.title),
      field_content_zh_descriptions: wDataById?.wZh?.data
        ? decodeHTML(wDataById?.wZh?.data?.descriptions)
        : decodeHTML(whistleblowingData?.[0]?.field_content_mandarin?.data?.descriptions),
      field_content_zh_wicStructure_image:
        wDataById?.wZh?.data
          ? decodeHTML([
              {
                uid: "-1",
                name: "WIC-Structure_image.png",
                status: "done",
                url: wDataById?.wZh?.data?.wicStructure?.image,
              },
            ])
          : whistleblowingData
            ? decodeHTML([
                {
                  uid: "-1",
                  name: "WIC-Structure_image.png",
                  status: "done",
                  url: whistleblowingData?.[0]?.field_content_mandarin?.data?.wicStructure?.image,
                },
              ])
            : [],
      field_content_zh_wicStructure_title: wDataById?.wZh?.data
        ? decodeHTML(wDataById?.wZh?.data?.wicStructure?.title)
        : decodeHTML(whistleblowingData?.[0]?.field_content_mandarin?.data?.wicStructure?.title),
      field_content_zh_procedure_image:
        wDataById?.wZh?.data 
          ? decodeHTML([
              {
                uid: "-1",
                name: "WIC-Structure_image.png",
                status: "done",
                url: wDataById?.wZh?.data?.procedure?.image,
              },
            ])
          : whistleblowingData
            ? decodeHTML([
                {
                  uid: "-1",
                  name: "WIC-Procedure_image.png",
                  status: "done",
                  url: whistleblowingData?.[0]?.field_content_mandarin?.data?.procedure?.image,
                },
              ])
            : [],
      field_content_zh_procedure_title: wDataById?.wZh?.data
        ? decodeHTML(wDataById?.wZh?.data?.procedure?.title)
        : decodeHTML(whistleblowingData?.[0]?.field_content_mandarin?.data?.procedure?.title),
      field_content_zh_next_page_name: wDataById?.wZh?.data
        ? decodeHTML(wDataById?.wZh?.data?.nextPage?.name)
        : decodeHTML(whistleblowingData?.[0]?.field_content_mandarin?.data?.nextPage?.name),
      field_content_zh_next_page_link: wDataById?.wZh?.data
        ? decodeHTML(wDataById?.wZh?.data?.nextPage?.link)
        : decodeHTML(whistleblowingData?.[0]?.field_content_mandarin?.data?.nextPage?.link),
    },
    fields: fields.whistleblowingProgramNextPage,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let excludedKeys: any = [];
    let imageKeys: any = [
      "field_content_english_image",
      "field_content_ms_image",
      "field_content_zh_image",
      "field_content_english_wicStructure_image",
      "field_content_english_procedure_image",
      "field_content_ms_wicStructure_image",
      "field_content_ms_procedure_image",
      "field_content_zh_wicStructure_image",
      "field_content_zh_procedure_image",
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CORPORATE");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    const payload = {
      action: action,
      method: method,
      module: "Corporate-integrity",
      subModule: `${query?.get("activeTab")}_${query.get('subActiveTab')}`,
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "MAHB_CORPORATE_Corporate-integrity_Whistleblowing Program",
      payload: {
        id: data?.id || whistleblowingData?.[0]?.id || corporateIntegrityById?.payload?.id,
        field_content_english: JSON.stringify(
          query?.get("activeTab") === "managementIntegrityMessage"
            ? {
                data: {
                  image: data?.field_content_english_image ?? "",
                  text: data?.field_content_english_text ?? "",
                  nextPage: {
                    name: data?.field_content_english_next_page_name ?? "",
                    link: data?.field_content_english_next_page_link ?? "",
                  },
                },
                labelData: {},
              }
            : query?.get("activeTab") === "antiBriberyCorruption"
              ? {
                  data: {
                    title: data?.field_content_english_title ?? "",
                    extroText: data?.field_content_english_extroText ?? "",
                    description: data?.field_content_english_description ?? "",
                    introText: data?.field_content_english_introText ?? "",
                    nextPage: {
                      name: data?.field_content_english_next_page_name ?? "",
                      link: data?.field_content_english_next_page_link ?? "",
                    },
                  },
                  labelData: {},
                }
              : query?.get("activeTab") === "whistleblowingProgram"
                ? {
                    data: {
                      title: data?.field_content_english_title ?? "",
                      descriptions: data?.field_content_english_descriptions ?? "",
                      wicStructure: {
                        title: data?.field_content_english_wicStructure_title ?? "",
                        image: data?.field_content_english_wicStructure_image ?? "",
                      },
                      procedure: {
                        title: data?.field_content_english_procedure_title ?? "",
                        image: data?.field_content_english_procedure_image ?? "",
                      },
                      nextPage: {
                        name: data?.field_content_english_next_page_name ?? "",
                        link: data?.field_content_english_next_page_link ?? "",
                      },
                    },
                  }
                : query?.get("activeTab") === "whistleblowingPolicy"
                  ? {
                      data: {
                        markup: data?.field_content_english_markup ?? "",
                        nextPage: {
                          name: data?.field_content_english_next_page_name ?? "",
                          link: data?.field_content_english_next_page_link ?? "",
                        },
                      },
                    }
                  : {
                      data: {
                        title: data?.field_content_english_title ?? "",
                        description: data?.field_content_english_description ?? "",
                        afterSubmit: {
                          succesMessage: data?.field_content_english_after_submit_succesMessage ?? "",
                          appreciationMessage: data?.field_content_english_after_submit_appreciationMessage ?? "",
                          backToForm: data?.field_content_english_after_submit_backToForm ?? "",
                        },
                        nextPage: {
                          name: data?.field_content_english_next_page_name ?? "",
                          link: data?.field_content_english_next_page_link ?? "",
                        },
                      },
                      labelData: {
                        persons: {
                          titleText: data?.field_content_english_persons_titleText ?? "",
                          nameFieldText: data?.field_content_english_persons_nameFieldText ?? "",
                          designationFieldText: data?.field_content_english_persons_designationFieldText ?? "",
                          divisionOrUnitFieldText: data?.field_content_english_persons_divisionOrUnitFieldText ?? "",
                          companyOrAirportFieldText: data?.field_content_english_persons_companyOrAirportFieldText ?? "",
                        },
                        concerns: {
                          titleText: data?.field_content_english_concerns_titleText ?? "",
                          dateTimeFieldText: data?.field_content_english_concerns_dateTimeFieldText ?? "",
                          locationOfIncidentFieldText: data?.field_content_english_concerns_locationOfIncidentFieldText ?? "",
                          detailsFieldText: data?.field_content_english_concerns_detailsFieldText ?? "",
                          otherPartiesInvolvedFieldText:
                            data?.field_content_english_concerns_otherPartiesInvolvedFieldText ?? "",
                          namesOfWitnessesInvolvedFieldText:
                            data?.field_content_english_concerns_namesOfWitnessesInvolvedFieldText ?? "",
                        },
                        yourParticulars: {
                          titleText: data?.field_content_english_yourParticulars_titleText ?? "",
                          fullnameFieldText: data?.field_content_english_yourParticulars_fullnameFieldText ?? "",
                          staffNoFieldText: data?.field_content_english_yourParticulars_staffNoFieldText ?? "",
                          contactNoFieldText: data?.field_content_english_yourParticulars_contactNoFieldText ?? "",
                          emailFieldText: data?.field_content_english_yourParticulars_emailFieldText ?? "",
                          companyNameFieldText: data?.field_content_english_yourParticulars_companyNameFieldText ?? "",
                        },
                        confidentialityText: data?.field_content_english_confidentialityText ?? "",
                        captcha: {
                          titleText: data?.field_content_english_captcha_titleText ?? "",
                          helpText: data?.field_content_english_captcha_helpText ?? "",
                          newCaptchaText: data?.field_content_english_captcha_newCaptchaText ?? "",
                        },
                        submitButtonText: data?.field_content_english_submitButtonText ?? "",
                      },
                    }
        ),
        field_content_malay: JSON.stringify(
          query?.get("activeTab") === "managementIntegrityMessage"
            ? {
                data: {
                  image: data?.field_content_english_image ?? "",
                  text: data?.field_content_ms_text ?? "",
                  nextPage: {
                    name: data?.field_content_ms_next_page_name ?? "",
                    link: data?.field_content_ms_next_page_link ?? "",
                  },
                },
                labelData: {},
              }
            : query?.get("activeTab") === "antiBriberyCorruption"
              ? {
                  data: {
                    title: data?.field_content_ms_title ?? "",
                    extroText: data?.field_content_ms_extroText ?? "",
                    description: data?.field_content_ms_description ?? "",
                    introText: data?.field_content_ms_introText ?? "",
                    nextPage: {
                      name: data?.field_content_ms_next_page_name ?? "",
                      link: data?.field_content_ms_next_page_link ?? "",
                    },
                  },
                  labelData: {},
                }
              : query?.get("activeTab") === "whistleblowingProgram"
                ? {
                    data: {
                      title: data?.field_content_ms_title ?? "",
                      descriptions: data?.field_content_ms_descriptions ?? "",
                      wicStructure: {
                        title: data?.field_content_ms_wicStructure_title ?? "",
                        image: data?.field_content_english_wicStructure_image ?? "",
                      },
                      procedure: {
                        title: data?.field_content_ms_procedure_title ?? "",
                        image: data?.field_content_english_procedure_image ?? "",
                      },
                      nextPage: {
                        name: data?.field_content_ms_next_page_name ?? "",
                        link: data?.field_content_ms_next_page_link ?? "",
                      },
                    },
                  }
                : query?.get("activeTab") === "whistleblowingPolicy"
                  ? {
                      data: {
                        markup: data?.field_content_ms_markup ?? "",
                        nextPage: {
                          name: data?.field_content_ms_next_page_name ?? "",
                          link: data?.field_content_ms_next_page_link ?? "",
                        },
                      },
                    }
                  : {
                      data: {
                        title: data?.field_content_ms_title ?? "",
                        description: data?.field_content_ms_description ?? "",
                        afterSubmit: {
                          succesMessage: data?.field_content_ms_after_submit_succesMessage ?? "",
                          appreciationMessage: data?.field_content_ms_after_submit_appreciationMessage ?? "",
                          backToForm: data?.field_content_ms_after_submit_backToForm ?? "",
                        },
                        nextPage: {
                          name: data?.field_content_ms_next_page_name ?? "",
                          link: data?.field_content_ms_next_page_link ?? "",
                        },
                      },
                      labelData: {
                        persons: {
                          titleText: data?.field_content_ms_persons_titleText ?? "",
                          nameFieldText: data?.field_content_ms_persons_nameFieldText ?? "",
                          designationFieldText: data?.field_content_ms_persons_designationFieldText ?? "",
                          divisionOrUnitFieldText: data?.field_content_ms_persons_divisionOrUnitFieldText ?? "",
                          companyOrAirportFieldText: data?.field_content_ms_persons_companyOrAirportFieldText ?? "",
                        },
                        concerns: {
                          titleText: data?.field_content_ms_concerns_titleText ?? "",
                          dateTimeFieldText: data?.field_content_ms_concerns_dateTimeFieldText ?? "",
                          locationOfIncidentFieldText: data?.field_content_ms_concerns_locationOfIncidentFieldText ?? "",
                          detailsFieldText: data?.field_content_ms_concerns_detailsFieldText ?? "",
                          otherPartiesInvolvedFieldText:
                            data?.field_content_ms_concerns_otherPartiesInvolvedFieldText ?? "",
                          namesOfWitnessesInvolvedFieldText:
                            data?.field_content_ms_concerns_namesOfWitnessesInvolvedFieldText ?? "",
                        },
                        yourParticulars: {
                          titleText: data?.field_content_ms_yourParticulars_titleText ?? "",
                          fullnameFieldText: data?.field_content_ms_yourParticulars_fullnameFieldText ?? "",
                          staffNoFieldText: data?.field_content_ms_yourParticulars_staffNoFieldText ?? "",
                          contactNoFieldText: data?.field_content_ms_yourParticulars_contactNoFieldText ?? "",
                          emailFieldText: data?.field_content_ms_yourParticulars_emailFieldText ?? "",
                          companyNameFieldText: data?.field_content_ms_yourParticulars_companyNameFieldText ?? "",
                        },
                        confidentialityText: data?.field_content_ms_confidentialityText ?? "",
                        captcha: {
                          titleText: data?.field_content_ms_captcha_titleText ?? "",
                          helpText: data?.field_content_ms_captcha_helpText ?? "",
                          newCaptchaText: data?.field_content_ms_captcha_newCaptchaText ?? "",
                        },
                        submitButtonText: data?.field_content_ms_submitButtonText ?? "",
                      },
                    }
        ),
        field_content_mandarin: JSON.stringify(
          query?.get("activeTab") === "managementIntegrityMessage"
            ? {
                data: {
                  image: data?.field_content_english_image ?? "",
                  text: data?.field_content_zh_text ?? "",
                  nextPage: {
                    name: data?.field_content_zh_next_page_name ?? "",
                    link: data?.field_content_zh_next_page_link ?? "",
                  },
                },
                labelData: {},
              }
            : query?.get("activeTab") === "antiBriberyCorruption"
              ? {
                  data: {
                    title: data?.field_content_zh_title ?? "",
                    extroText: data?.field_content_zh_extroText ?? "",
                    description: data?.field_content_zh_description ?? "",
                    introText: data?.field_content_zh_introText ?? "",
                    nextPage: {
                      name: data?.field_content_zh_next_page_name ?? "",
                      link: data?.field_content_zh_next_page_link ?? "",
                    },
                  },
                  labelData: {},
                }
              : query?.get("activeTab") === "whistleblowingProgram"
                ? {
                    data: {
                      title: data?.field_content_zh_title ?? "",
                      descriptions: data?.field_content_zh_descriptions ?? "",
                      wicStructure: {
                        title: data?.field_content_zh_wicStructure_title ?? "",
                        image: data?.field_content_english_wicStructure_image ?? "",
                      },
                      procedure: {
                        title: data?.field_content_zh_procedure_title ?? "",
                        image: data?.field_content_english_procedure_image ?? "",
                      },
                      nextPage: {
                        name: data?.field_content_zh_next_page_name ?? "",
                        link: data?.field_content_zh_next_page_link ?? "",
                      },
                    },
                  }
                : query?.get("activeTab") === "whistleblowingPolicy"
                  ? {
                      data: {
                        markup: data?.field_content_zh_markup ?? "",
                        nextPage: {
                          name: data?.field_content_zh_next_page_name ?? "",
                          link: data?.field_content_zh_next_page_link ?? "",
                        },
                      },
                    }
                  : {
                      data: {
                        title: data?.field_content_zh_title ?? "",
                        description: data?.field_content_zh_description ?? "",
                        afterSubmit: {
                          succesMessage: data?.field_content_zh_after_submit_succesMessage ?? "",
                          appreciationMessage: data?.field_content_zh_after_submit_appreciationMessage ?? "",
                          backToForm: data?.field_content_zh_after_submit_backToForm ?? "",
                        },
                        nextPage: {
                          name: data?.field_content_zh_next_page_name ?? "",
                          link: data?.field_content_zh_next_page_link ?? "",
                        },
                      },
                      labelData: {
                        persons: {
                          titleText: data?.field_content_zh_persons_titleText ?? "",
                          nameFieldText: data?.field_content_zh_persons_nameFieldText ?? "",
                          designationFieldText: data?.field_content_zh_persons_designationFieldText ?? "",
                          divisionOrUnitFieldText: data?.field_content_zh_persons_divisionOrUnitFieldText ?? "",
                          companyOrAirportFieldText: data?.field_content_zh_persons_companyOrAirportFieldText ?? "",
                        },
                        concerns: {
                          titleText: data?.field_content_zh_concerns_titleText ?? "",
                          dateTimeFieldText: data?.field_content_zh_concerns_dateTimeFieldText ?? "",
                          locationOfIncidentFieldText:
                            data?.field_content_zh_concerns_locationOfIncidentFieldText ?? "",
                          detailsFieldText: data?.field_content_zh_concerns_detailsFieldText ?? "",
                          otherPartiesInvolvedFieldText:
                            data?.field_content_zh_concerns_otherPartiesInvolvedFieldText ?? "",
                          namesOfWitnessesInvolvedFieldText:
                            data?.field_content_zh_concerns_namesOfWitnessesInvolvedFieldText ?? "",
                        },
                        yourParticulars: {
                          titleText: data?.field_content_zh_yourParticulars_titleText ?? "",
                          fullnameFieldText: data?.field_content_zh_yourParticulars_fullnameFieldText ?? "",
                          staffNoFieldText: data?.field_content_zh_yourParticulars_staffNoFieldText ?? "",
                          contactNoFieldText: data?.field_content_zh_yourParticulars_contactNoFieldText ?? "",
                          emailFieldText: data?.field_content_zh_yourParticulars_emailFieldText ?? "",
                          companyNameFieldText: data?.field_content_zh_yourParticulars_companyNameFieldText ?? "",
                        },
                        confidentialityText: data?.field_content_zh_confidentialityText ?? "",
                        captcha: {
                          titleText: data?.field_content_zh_captcha_titleText ?? "",
                          helpText: data?.field_content_zh_captcha_helpText ?? "",
                          newCaptchaText: data?.field_content_zh_captcha_newCaptchaText ?? "",
                        },
                        submitButtonText: data?.field_content_zh_submitButtonText ?? "",
                      },
                    }
        ),
        field_page: whistleblowingData?.[0]?.field_page || corporateIntegrityById?.payload?.field_page || "",
        published: true,
      },
      status: status,
    };

    console.log("payload", payload.payload);
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <DynamicForm
        isLoading={
          isLoadingWhistleblowing ||
          isLoadingCorporateIntegrityById
        }
          config={WhistleblowingConfig}
          onSubmit={(data, buttonValue, reviewNotes) =>
            onSubmit(
              data,
              `${corporateHost}/api/page-content/${whistleblowingData?.[0]?.id || corporateIntegrityById?.payload?.id || '84'}`,
              "UPDATE",
              "PATCH",
              buttonValue == "save" ? "DRAFT" : "PENDING",
              reviewNotes
            )
          }
          defaultReviewNotes="Kindly review this Corporate Integrity"
        />
  );
};
